import { FirstSectionRegister } from "./components/firstSection";


export const RegisterPage = () => {
    return (
        <div>
            <FirstSectionRegister/>
        </div>
    );
};

